<script>
//import { Html5QrcodeScanner } from "html5-qrcode";
import { Html5Qrcode } from "html5-qrcode";
export default {
  name: "qrcode-scanner",
  props: {
    qrbox: {
      type: Number,
      default: 250,
    },
    fps: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      html5QrCode: null,
    }
  },
  mounted() {
    const config = {
      fps: this.fps,
      qrbox: this.qrbox,
    };
    /*
    const html5QrcodeScanner = new Html5QrcodeScanner(
      "qr-code-full-region",
      config
    );
    html5QrcodeScanner.render(this.onScanSuccess);*/

    this.html5QrCode = new Html5Qrcode("qr-code-full-region");
    this.html5QrCode
      .start(
        { facingMode: "environment" },
        config,
        (decodedText, decodedResult) => {
          this.onScanSuccess(decodedText, decodedResult);
        },
        (errorMessage) => {
          console.log(errorMessage)
        }
      )
      .catch((err) => {
        console.log(err)
      });
  },
  beforeDestroy() {
    this.html5QrCode?.stop().then(() => {
      
    }).catch((err) => {
      console.log(err)
    });
  },
  destroyed() {
    
  },
  methods: {
    onScanSuccess(decodedText, decodedResult) {
      this.$emit("result", decodedText, decodedResult);
    },
  },
};
</script>

<template>
  <div id="qr-code-full-region"></div>
</template>